<template>
	<div class="chat-miniprogram-message">
		<img :src="data[keys]" class="image" alt="图片异常"/>
		<div class="title">
			<span>{{data.title}}</span>
			<a v-show="data.pagepath.indexOf('http') > -1 " :href="data.pagepath"
				target="_blank">查看更多</a>
		</div>
		<div class="bottom" v-show="isShowMoney">
			<span v-show="data.sku">{{data.sku}}</span>
			<span v-show="data.price"><i class="iconfont major-renminbi"></i>{{formatMoney(data.price)}}</span>
		</div>
	</div>
</template>
<script>
	export default {
		props:{
			data:{
				required:true
			},
			keys:{
				default:'thumbMediaId'
			},
			isShowMoney:{
				default:false
			}
		},
		methods: {
			formatMoney(data){
				let money = data;
				if(money && money != null) {
					money = String(money);
					let left = money.split('.')[0];
					let right = money.split('.')[1];
						right = right ? (right.length>=2 ? '.'+right.substr(0,2) : '.'+right+'0') : '.00';
					let temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
					return (Number(money)<0?"-":"") + temp.join(',').split('').reverse().join('')+right
				}else if(money == 0) {
					return '0.00'
				}else {
					return ''
				}
			}
		}
	}
</script>
<style scoped lang="scss">
	.chat-miniprogram-message {
		width: 200px;
		font-size: 14px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		padding: 10px 20px ;
		img {
			height: 100px;
			object-fit: contain;
		}
		.title,.bottom {
			margin-top: 5px;
			span {
				display: inline-block;
				width: 50%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			a {
				float: right;
				color: #0F81FB;
			}
		}
		.bottom {
			.iconfont {
				font-weight: normal;
				font-size: 12px;
			}
		}
	}
</style>
